module.exports = __webpack_public_path__ + "static/media/image-modal.ccba15da.png";